<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Leistungen</h1>
<!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <ServicesMonth></ServicesMonth>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <ServicesYear></ServicesYear>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <InvoiceSubscription></InvoiceSubscription>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <ServicesYearFree></ServicesYearFree>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <services-table title="Leistungen"></services-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ServicesTable from "@/views/Tables/ServicesTable";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import ServicesMonth from "@/views/Widgets/ServicesMonth";
import InvoiceSubscription from "@/views/Widgets/InvoiceSubscription";
import ServicesYear from "@/views/Widgets/ServicesYear";
import ServicesYearFree from "@/views/Widgets/ServicesYearFree";

export default {
    name: "Services",
    components: {
        ServicesTable,
        RouteBreadCrumb,
        ServicesMonth,
        InvoiceSubscription,
        ServicesYear,
        ServicesYearFree,
    },
}
</script>

<style scoped>

</style>
